<template>
  <aw-dropdown
    placement="bottom-start"
    :offset="[0, 0]"
    class="relative"
  >
    <template v-slot:btn="{ toggle }">
      <a
        v-if="showDownloadBtn && downloadableFiles.length <= 1"
        :href="downloadableFiles[0] ? downloadableFiles[0].file.download_url.original : '#'"
        target="_blank"
        :class="{'muted': !isActiveDownloadBtn, '!text-bc-blue': isActiveDownloadBtn && $route.matched[0].name === 'BCSharedDocument', 'text-gray-500  hover:text-gray-200': isGalleryModal}"
        @click.stop.prevent="downloadFile"
        @contextmenu.prevent.stop="toggle"
      >
        <aw-icon icon="download" class="w-5 h-5 "></aw-icon>
        <span v-if="!isGalleryModal">
          {{$t('Download')}}
        </span>
      </a>
      <right-menu-item
        v-else-if="showDownloadBtn && downloadableFiles.length > 1"
        @click.prevent="downloadZip"
        @contextmenu.prevent.stop="toggle"
        :class="{ 'muted': !isActiveDownloadBtn, '!text-bc-blue': isActiveDownloadBtn && $route.matched[0].name === 'BCSharedDocument', 'text-gray-500  hover:text-gray-200': isGalleryModal }"
        :text="isGalleryModal ? '' : $t('Download as ZIP')"
        :loading="loading"
        icon="download"
      />
    </template>
    <template v-slot:dropdown="{ opened, dropdown, close }">
      <div
        v-show="opened"
        :ref="dropdown"
        class="Dropdown Dropdown--Hover absolute rounded-md bg-white  max-w-xs text-sm top-full right-0 shadow-md z-10 !min-w-0"
      >
        <nav class="p-0 text-left">
          <a
            v-if="showDownloadBtn && downloadableFiles.length > 1"
            class="block py-1.5 px-3 text-gray-600 hover:text-gray-800 !mb-0"
            href="#"
            @click.stop.prevent="copyZipLink(close)"
            >{{ $t('Copy link address') }}</a
          >
          <a
            v-if="showDownloadBtn && downloadableFiles.length <= 1"
            class="block py-1.5 px-3 text-gray-600 hover:text-gray-800 !mb-0"
            href="#"
            @click.stop.prevent="copyLink(close)"
            >{{ $t('Copy link address') }}</a
          >
        </nav>
      </div>
    </template>
  </aw-dropdown>
</template>

<script>
import DownloadButton from '../../mixins/DownloadButton'
import { useClipboard } from '@vueuse/core'
import ShareGalleryModal from '../../mixins/ShareGalleryModal'

export default {
  mixins: [
    DownloadButton,
    ShareGalleryModal
  ],
  methods: {
    copyLink(close) {
      const clipboard = useClipboard()
      clipboard.copy(
        this.downloadableFiles[0].file.download_url.original
      )
      close()
    }
  }
}
</script>

<style lang="scss" scoped></style>
